import ReportHandle from '@/pages/handle/reportHandle'

export default [
  {
    path: '/reportHandle',
    name: 'ReportHandle',
    component: ReportHandle,
    meta: { name: '报备处理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/handle/reportHandle.js